import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import H5 from 'UIComponents/elements/headings/H5';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import { SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { useFlowReferences } from 'automation-ui-management/hooks/flowReferencesHook';
import { FLOW_REFERENCES_FIELDNAME } from 'automation-ui-management/queries/flowReferenceQueries';
import InboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/InboundFlowReferencesSection';
import OutboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/OutboundFlowReferencesSection';
import WorkflowReferenceFailureAlert from 'automation-ui-management/components/workflow-references/WorkflowReferenceFailureAlert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FlowReferencesPanel = ({
  flowId,
  onClose,
  flowName
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useFlowReferences({
    flowId,
    flowSource: PLATFORM,
    includeOutboundReferences: true
  });
  const inboundReferences = data && data[FLOW_REFERENCES_FIELDNAME] ? data[FLOW_REFERENCES_FIELDNAME].inboundReferences : [];
  const outboundReferences = data && data[FLOW_REFERENCES_FIELDNAME] ? data[FLOW_REFERENCES_FIELDNAME].outboundReferences : [];
  const renderInboundFlowReferences = references => {
    return /*#__PURE__*/_jsx(InboundFlowReferencesSection, {
      inboundReferences: references
    });
  };
  const renderOutboundFlowReferences = references => {
    return /*#__PURE__*/_jsx(OutboundFlowReferencesSection, {
      outboundReferences: references
    });
  };
  let panelBodyContent = null;
  if (loading) {
    panelBodyContent = /*#__PURE__*/_jsx(UILoadingSpinner, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.flowReferencesPanel.checkingReferences"
      }),
      showLabel: true,
      layout: "centered",
      size: "small",
      grow: true
    });
  } else if (error) {
    panelBodyContent = /*#__PURE__*/_jsx(WorkflowReferenceFailureAlert
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    , {
      handleRequestReferences: () => refetch()
    });
  } else {
    panelBodyContent = /*#__PURE__*/_jsxs(_Fragment, {
      children: [flowName && /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "500",
        as: "div",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-bottom-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-management.flowReferencesPanel.workflowNameSectionHeader"
          })
        }), flowName]
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "500",
        as: "div",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-management.flowReferencesPanel.outboundSectionHeader"
          })
        }), renderOutboundFlowReferences(outboundReferences)]
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "500",
        as: "div",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-management.flowReferencesPanel.inboundSectionHeader"
          })
        }), renderInboundFlowReferences(inboundReferences)]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: SIDE_PANEL_WIDTH,
    "data-test-id": "connections-panel-root",
    children: [/*#__PURE__*/_jsxs(UIPanelHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.flowReferencesPanel.panelHeader"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsx(UIPanelSection, {
        children: panelBodyContent
      })
    })]
  });
};
export default FlowReferencesPanel;